import { api } from './utils'

export enum GetChangePasswordTokenAnswer {
	NOT_AUTHORIZED = 'NOT_AUTHORIZED',
	BAD_PASSWORD = 'BAD_PASSWORD',
	MFA_REQUIRED = 'MFA_REQUIRED',
	BAD_MFA = 'BAD_MFA',
}

export enum ChangePasswordAnswer {
	NOT_AUTHORIZED = 'NOT_AUTHORIZED',
	BAD_PASSWORD = 'BAD_PASSWORD',
	BAD_TOKEN = 'BAD_TOKEN',
}

interface IGetChangePasswordTokenSuccessAnswer {
	success: true
	token: string
}

interface IGetChangePasswordTokenBadAnswer {
	success: false
	message: GetChangePasswordTokenAnswer
}

interface IChangePasswordSuccessAnswer {
	success: true
}

interface IChangePasswordBadAnswer {
	success: false
	message: ChangePasswordAnswer
}

export type GetChangePasswordTokenAnswerType =
    IGetChangePasswordTokenSuccessAnswer | IGetChangePasswordTokenBadAnswer

export type ChangePasswordAnswerType =
    IChangePasswordSuccessAnswer | IChangePasswordBadAnswer

export async function getChangePasswordToken(
	oldPassword: string,
	mfaCode: string
): Promise<GetChangePasswordTokenAnswerType> {
	return await (await fetch(
		`${api}/cabinet/prepareChangePassword`,
		{
			method: 'POST',
			body: JSON.stringify({
				oldPassword, mfaCode
			})
		}
	)).json() as GetChangePasswordTokenAnswerType
}

export async function changePassword(
	token: string,
	newPassword: string
): Promise<ChangePasswordAnswerType> {
	return await (await fetch(
		`${api}/cabinet/changePassword`,
		{
			method: 'POST',
			body: JSON.stringify({
				token, newPassword
			})
		}
	)).json() as ChangePasswordAnswerType
}
